import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button } from 'reactstrap';
import { Link } from "react-router-dom";
import CreateBanner from "./create_banner"

let moment = require("moment");


class Marketing extends Component {
render() {
    
    return (
        <>
            <h3 className="mb-4">Manage App Content</h3>
            <Row className="mb-3">
                <Col lg={3} xs={12} >
                    <Button id="Banner" onClick={()=>{this.props.history.push("/marketing/create_Banner");}}  type="button" className="buttonred w-100" size="lg" style={{ padding: 10 }}><b>App Banners</b></Button>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col lg={3} xs={12}>
                    <Button id="Videos" onClick={()=>{this.props.history.push("/marketing/videos");}}  type="button" className="buttonred w-100" size="lg" style={{ padding: 10 }}><b>App Videos</b></Button>
                </Col>
            </Row>
        </>
    )}};

export default Marketing;